import { Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  ARRIVAL_INSTRUCTIONS_MAX_LENGTH,
  JOB_DESCRIPTION_MAX_LENGTH,
} from "../../../../app/constants";
import { TextFieldLight } from "../../../../common/components/styled/styled";
import { OrderRowDescriptions } from "../../orderTypes";

type Props = {
  isAutomatchingOn: boolean;
  isExpertAuthorizedToEdit: boolean;
  values: OrderRowDescriptions;
  handleDescriptionsChange: (values: OrderRowDescriptions) => void;
  isReadOnly: boolean;
};

export const Descriptions = ({
  isAutomatchingOn,
  isExpertAuthorizedToEdit,
  values,
  handleDescriptionsChange,
  isReadOnly,
}: Props) => {
  const { t } = useTranslation("order");

  const handleChange = (name: string, value: any) => {
    handleDescriptionsChange({
      ...values,
      [name]: value,
    });
  };

  return (
    <>
      <Grid container item xs={3} justifyContent="flex-end" alignItems="center">
        <Typography variant="secondary">{t("jobDescriptionFI")}</Typography>
      </Grid>
      <Grid item xs={9}>
        <TextFieldLight
          disabled={isAutomatchingOn || !isExpertAuthorizedToEdit || isReadOnly}
          fullWidth
          multiline
          minRows={4}
          value={values.description}
          onChange={(e) => handleChange("description", e.target.value)}
          inputProps={{ maxLength: JOB_DESCRIPTION_MAX_LENGTH }}
        />
      </Grid>
      <Grid
        container
        item
        xs={3}
        justifyContent="flex-end"
        alignItems="center"
        sx={{ marginBottom: "20px" }}
      >
        <Typography variant="secondary">
          {t("arrivalInstructionsFI")}
        </Typography>
      </Grid>
      <Grid item xs={9}>
        <TextFieldLight
          disabled={!isExpertAuthorizedToEdit || isReadOnly}
          fullWidth
          size="small"
          name="descriptionForTalent"
          value={values.descriptionForTalent}
          onChange={(e) => handleChange("descriptionForTalent", e.target.value)}
          helperText={t("arrivalInstructionsHelper")}
          inputProps={{ maxLength: ARRIVAL_INSTRUCTIONS_MAX_LENGTH }}
          multiline
          minRows={1}
        />
      </Grid>
      <Grid container item xs={3} justifyContent="flex-end" alignItems="center">
        <Typography variant="secondary">{t("jobDescriptionEN")}</Typography>
      </Grid>
      <Grid item xs={9}>
        <TextFieldLight
          disabled={isAutomatchingOn || !isExpertAuthorizedToEdit || isReadOnly}
          fullWidth
          multiline
          minRows={4}
          value={values.descriptionEn}
          onChange={(e) => handleChange("descriptionEn", e.target.value)}
          inputProps={{ maxLength: JOB_DESCRIPTION_MAX_LENGTH }}
        />
      </Grid>
      <Grid
        container
        item
        xs={3}
        justifyContent="flex-end"
        alignItems="center"
        sx={{ marginBottom: "20px" }}
      >
        <Typography variant="secondary">
          {t("arrivalInstructionsEN")}
        </Typography>
      </Grid>
      <Grid item xs={9}>
        <TextFieldLight
          disabled={!isExpertAuthorizedToEdit || isReadOnly}
          fullWidth
          multiline
          minRows={1}
          size="small"
          name="descriptionForTalentEng"
          value={values.descriptionForTalentEn}
          onChange={(e) =>
            handleChange("descriptionForTalentEn", e.target.value)
          }
          helperText={t("arrivalInstructionsHelper")}
          inputProps={{ maxLength: ARRIVAL_INSTRUCTIONS_MAX_LENGTH }}
        />
      </Grid>
    </>
  );
};
